// extracted by mini-css-extract-plugin
module.exports = {"sub-title":"ResetPassword_sub-title__lkLHK","errorMessage":"ResetPassword_errorMessage__3kZ4X","return-login":"ResetPassword_return-login__3fv4V"};